import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserOperatorsEditService {

  constructor(private http: HttpClient) { }

  public isFetchingUserOperators: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public fetchUserOperators(userId: number) {

    var prom = new Promise((resolve, reject) => {

      var url = "api/Users/admin/" + userId.toString() + "/operators";

      this.http.get(url).toPromise().then((result) => {
        resolve(result);
      },
        (err) => {
          reject(err);
      }
      );
    });

    return prom;
  }

  public removeOperatorJunction(userId: number, operatorId: number) {
    var prom = new Promise<void>((resolve, reject) => {
      var url = "api/Users/admin/" + userId.toString() + "/operators/" + operatorId;

      this.http.delete(url).toPromise().then((result) => {
        resolve();
      },
      (err) => {
        reject(err);
      });
    });

    return prom;
  }

  public approveUserForOperator(junction: any) {
    var prom = new Promise<void>((resolve, reject) => {
      var url = "api/Users/admin/" + junction.UserId + "/operators/" + junction.OperatorId + "/approve";
      this.http.get(url).toPromise().then(() => {
        resolve();
      },
      (err) => {
        reject(err);
      });
    });

    return prom;
  }

  public unapproveUserForOperator(junction: any) {
    var prom = new Promise<void>((resolve, reject) => {
      var url = "api/Users/admin/" + junction.UserId + "/operators/" + junction.OperatorId + "/unapprove";
      this.http.get(url).toPromise().then(() => {
        resolve();
      },
        (err) => {
          reject(err);
        });
    });

    return prom;
  }

  public grantApproverForUser(junction: any) {
    var prom = new Promise<void>((resolve, reject) => {
      var url = "api/Users/admin/" + junction.UserId + "/operators/" + junction.OperatorId + "/grantapprover";
      this.http.get(url).toPromise().then(() => {
        resolve();
      },
        (err) => {
          reject(err);
        });
    });

    return prom;
  }

  public revokeApproverForUser(junction: any) {
    var prom = new Promise<void>((resolve, reject) => {
      var url = "api/Users/admin/" + junction.UserId + "/operators/" + junction.OperatorId + "/revokeapprover";
      this.http.get(url).toPromise().then(() => {
        resolve();
      },
        (err) => {
          reject(err);
        });
    });

    return prom;
  }
}
